import React from 'react';
import ButtonBase from '../../../Buttons/ButtonBase';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import './MakeYourQuestion.scss';
const Scroll = require('react-scroll');
const scroller = Scroll.scroller;

const useStyles = makeStyles({
    buttonStyle: {
        minWidth: 200,
    }
})

const MakeYourQuestion = ({ isLawyer }) => {

    const classes = useStyles()
    const history = useHistory()

    const actionWithBanner = () => {
        if (isLawyer) {
            // console.log('scrollea hacia arriba');
            scroller.scrollTo('responseQuestion', { smooth: true, offset: 0 });
        } else {
            history.push('/comunidad')
        }
    }

    return (
        <div className='makeYourQuestion'>
            <p className='makeYourQuestion-title'>
                {isLawyer ?
                    'Responde a esta pregunta e interactua con posibles clientes' :
                    'Realiza tu pregunta a la comunidad de abogados expertos de Contacta Abogado®'
                }
            </p>
            <ButtonBase
                variant='primary'
                buttonStyle={classes.buttonStyle}
                onClick={actionWithBanner}
            >
                {isLawyer ?
                    'Responder pregunta' :
                    'Realizar pregunta'
                }
            </ButtonBase>
        </div>
    )
}

export default MakeYourQuestion;
